import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';

import Header from '../../components/Header';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';
import Item from '../../components/Item';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import Container from '../../components/Container';
import './styles.css';

const messages = defineMessages({
  noResults: {
    id: 'search-results.noneFound',
    defaultMessage: 'No results found.',
  },
  tryAgain: {
    id: 'search-results.tryAgain',
    defaultMessage: 'Please try a new search.',
  },
  moreResults: {
    id: 'search-results.morePeople',
    defaultMessage: 'More People',
  },
  view: {
    id: 'search-results.view',
    defaultMessage: 'view',
  },
});

class AdvancedPeopleResults extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    loadMore: PropTypes.func.isRequired,
  };

  state = { loading: false };

  loadMore = () => {
    this.setState({ loading: true });
    this.props.loadMore('viewer.advancedPeopleSearch').then(() => this.setState({ loading: false }));
  };

  render() {
    const { viewer } = this.props;
    if (!get(viewer, 'advancedPeopleSearch.edges.length')) {
      return (
        <Item.Group>
          <Item styleName="noResultsContainer">
            <Item.Content>
              <Item.Header as="h3" styleName="noResultsHeader"><FormattedMessage {...messages.noResults} /></Item.Header>
              <Item.Description styleName="noResultsDescription"><FormattedMessage {...messages.tryAgain} /></Item.Description>
            </Item.Content>
          </Item>
        </Item.Group>
      );
    } else {
      const rows = viewer.advancedPeopleSearch.edges.map((People) => People.node);
      return (
        <div>
          <Header as="h2" styleName="resultsHeader">Search Results</Header>
          <Item.Group>
            {rows.map((row, index) => (
              <Item key={row.id} styleName="itemContainer">
                <Avatar big icon="user" image={row.field_profile_picture_file_url} />
                <Item.Content styleName="itemContent" data-cy={`advanced-people-search-results-${row.name}`}>
                  <Item.Header as="h3" styleName="itemHeader" data-cy="advanced-person-name">{row.name}</Item.Header>
                  <Item.Description styleName="itemDescription" data-cy="advanced-person-description">
                    {row.field_job_position && `${row.field_job_position} at `}
                    {row.field_user_institution_title &&
                      <Link to={`/counselor-community/institution/${row.field_user_institution}`}>{row.field_user_institution_title}</Link>}
                  </Item.Description>
                  <Item.Description styleName="itemDescription" data-cy="advanced-person-detail">
                    {row.field_general_description}
                  </Item.Description>
                  <Button
                    as={Link}
                    to={`/counselor-community/profile/${row.communityId}`}
                    size="tiny"
                  >
                    <Icon name="user plus" />
                    <FormattedMessage {...messages.view} />
                  </Button>
                </Item.Content>
              </Item>
            ))}
          </Item.Group>
          {get(viewer, 'advancedPeopleSearch.pageInfo.hasNextPage') ? (
            <Container textAlign="center">
              <Loader inline active={this.state.loading} />
              <Button size="small" primary onClick={this.loadMore}>
                <FormattedMessage {...messages.moreResults} />
              </Button>
            </Container>
          ) : null}
        </div>
      );
    }
  }
}

export default AdvancedPeopleResults;
